__turbopack_context__.v({
  "card": "heroMobileList-module-scss-module__fdgzJa__card",
  "content": "heroMobileList-module-scss-module__fdgzJa__content",
  "ctaArrow": "heroMobileList-module-scss-module__fdgzJa__ctaArrow",
  "ctaLink": "heroMobileList-module-scss-module__fdgzJa__ctaLink",
  "headline": "heroMobileList-module-scss-module__fdgzJa__headline",
  "mailOfferRow": "heroMobileList-module-scss-module__fdgzJa__mailOfferRow",
  "mobileList": "heroMobileList-module-scss-module__fdgzJa__mobileList",
  "promotion": "heroMobileList-module-scss-module__fdgzJa__promotion",
  "thumbnail": "heroMobileList-module-scss-module__fdgzJa__thumbnail",
});
